import React from 'react'
import { Switch, Route } from 'react-router-dom'
import CloseIcon from '@material-ui/icons/Close'


import { languageUrlPart } from '../../../routes/routes';
import { INearByTour } from '../../../screens/tours/common';

enum BackModeEnum {
    Default,
    Close
} 

interface IBackButtonProps {
    onBack: () => void
    backMode?: BackModeEnum
}

const BackButtonCore = ({ onBack, backMode} : IBackButtonProps) => {
    return (
        <button className="cta cta-back header-left-sm" style={{ paddingLeft: 0, paddingRight: backMode === BackModeEnum.Close ? '0.75rem' : undefined}} onClick={onBack}>
            {backMode !== BackModeEnum.Close
            ? <img src="/images/icons/icon-back.png" alt="back" />
            : <CloseIcon style={{verticalAlign: 'middle'}}/>}
        </button>
    )
}

export const BackButton = () => {
    return (
        <Switch>
            <Route exact path={`${languageUrlPart}/:countrySlug/:regionSlug/:citySlug/:tourSlug`} render={({ history }) => {
                return <BackButtonCore onBack={() => history.goBack()} />
            }} />
            <Route path={[
                `${languageUrlPart}/around-me`,
                `${languageUrlPart}/:countrySlug`,
                `${languageUrlPart}/:countrySlug/find`,
                `${languageUrlPart}/:countrySlug/:regionSlug`,
                `${languageUrlPart}/:countrySlug/:regionSlug/:citySlug`,
                `${languageUrlPart}/:countrySlug/:regionSlug/:citySlug/:tourSlug/nearby`,
            ]} render={({ history, location: { state: { nearByTour = undefined}} }) => {
                const actualNearByTour = nearByTour as INearByTour
                return actualNearByTour ? <BackButtonCore backMode={BackModeEnum.Close} onBack={() => history.goBack()}/> : null
            }} />
        </Switch>
    )
}